import { FC } from 'react'
import CloseIcon from '@mui/icons-material/Close'

import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitleRow,
  ModalTitleWrapper,
  ModalTitle,
  CloseButton,
  ModalDescription,
  ModalActions,
  CancelButton,
  CancelButtonText,
  DeleteButton,
  DeleteButtonText
} from './deleteChatModal.styles'

interface DeleteChatModalProps {
  isOpen: boolean
  chatName: string
  onClose: () => void
  onConfirm: () => void
}

const DeleteChatModal: FC<DeleteChatModalProps> = ({ isOpen, chatName, onClose, onConfirm }) => {
  if (!isOpen) return null

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContainer>
        <ModalHeader>
          <ModalTitleRow>
            <ModalTitleWrapper>
              <ModalTitle>Delete Chat '{chatName}'</ModalTitle>
            </ModalTitleWrapper>
            <CloseButton onClick={onClose}>
              <CloseIcon sx={{ fontSize: 24 }} />
            </CloseButton>
          </ModalTitleRow>
          <ModalDescription>
            This will permanently delete this chat and its generated insights.
            <br />
            This action can't be undone.
          </ModalDescription>
        </ModalHeader>

        <ModalActions>
          <CancelButton onClick={onClose}>
            <CancelButtonText>Cancel</CancelButtonText>
          </CancelButton>
          <DeleteButton onClick={onConfirm}>
            <DeleteButtonText>Delete</DeleteButtonText>
          </DeleteButton>
        </ModalActions>
      </ModalContainer>
    </ModalOverlay>
  )
}

export default DeleteChatModal
